import { BaseEnvironment, EnvironmentEnum } from "./environment.base";

export const environment = new BaseEnvironment({
  env: EnvironmentEnum.DEV,
  production: false,
  logLevel: 'All',
  apiUrl: 'api.dev.ampre.ca/api',
  // apiUrl: '/api',
  publicApiUrl: 'public.dev.ampre.ca',
  // publicApiUrl: '/public-api',
  shapeApiUrl: 'gisapi.uat.ampre.ca',
  // shapeApiUrl: '/shape-api',
  pdfApiUrl: 'pdf.dev.ampre.ca',
  // pdfApiUrl: '/pdf-api',
  dataMappingUrl: 'data-mapping.dev.ampre.ca',
  // dataMappingUrl: 'localhost:8500',
  videoMarketingUrl: 'dev-video.supreme.one',
  // videoMarketingUrl: 'localhost:6510',
  videoMarketingApi: 'dev-video-api.supreme.one',
  // videoMarketingApi: '/video-marketing-api',
  loginRoute: 'admin',
  disableAdminLogin: false,
  confirmAction: false,
  aiUrl: 'ai-enrichments.ampre.ca'
});
